export const TRANSACTION_KINDS = {
  credit: "CREDIT",
  debit: "DEBIT",
};

export const TRANSACTION_PAYMENT_CHANNELS = {
  inStore: "IN_STORE",
  online: "ONLINE",
};

export const STATEMENT_KINDS = {
  creditCard: "CREDIT_CARD",
  bank: "BANK",
};

export const STATEMENT_STATUSES = {
  notStarted: "NOT_STARTED",
  succeeded: "SUCCEEDED",
  failed: "FAILED",
  extracting: "EXTRACTING",
  categorizing: "CATEGORIZING",
  duplicated: "DUPLICATED",
};

export const PROJECT_STATUSES = {
  notStarted: "NOT_STARTED",
  succeeded: "SUCCEEDED",
  failed: "FAILED",
  processing: "PROCESSING",
};

export const PROJECT_REPORT_STATUSES = {
  notStarted: "NOT_STARTED",
  generated: "GENERATED",
  failed: "FAILED",
  generating: "GENERATING",
};
